import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import Select from 'react-select';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import * as commonActions from '../common/redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomLoader from '../common/CustomLoader';
import { PREVIEW, environmentSwitchOptions } from '../../common/utils/environments';
export class DefaultPage extends Component {
  static propTypes = {
    logger: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    lines: 100,
    searchTerm: '',
    environment: { value: PREVIEW, label: 'Preview / Staging (Default) Data', icon: 'eye-fill' },
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetail({ projectId, version }).then(({ data }) => {
      actions.loadPreviewLogs({
        seoName: data.seoName,
        projectId: data.uuid,
        lines: this.state.lines,
        environment: this.state.environment.value,
      });
    });
  }

  handleSearhTerm = (event) => {
    const { target } = event;
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  handleLimitChange = (event) => {
    const { target } = event;
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  handleEnvironmentChange = (environment) => {
    this.setState({ environment });
    const { home, actions } = this.props;
    const { lines, searchTerm } = this.state;
    const { projectDetail } = home;
    actions.loadPreviewLogs({
      seoName: projectDetail.seoName,
      projectId: projectDetail.uuid,
      lines,
      searchTerm,
      environment: environment.value,
    });
  };

  refreshLogs = () => {
    const { home, actions } = this.props;
    const { lines, searchTerm, environment } = this.state;
    const { projectDetail } = home;
    console.log('Loading Refresh Logs from refreshLogs');
    actions.loadPreviewLogs({
      seoName: projectDetail.seoName,
      projectId: projectDetail.uuid,
      lines,
      searchTerm,
      environment: environment.value,
    });
  };

  render() {
    const { searchTerm, lines, environment } = this.state;
    console.log('environment', environment);
    const { home, logger } = this.props;
    const { projectDetail, loadProjectDetailPending } = home;
    const { logs, loadPreviewLogsPending } = logger;
    const colourStyles = {
      control: (styles) => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
    };

    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-violet"
                  >
                    <i className={`wb ${drapcodeIcon('template')}`}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-title-header">
                      <h4 className="card-title">Logs</h4>
                      <div className="card-cta"></div>
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        this.refreshLogs();
                      }}
                    >
                      <div className="row">
                        <div className="col-md-3 col-lg-3">
                          <CustomInputWithIcon icon="select">
                            <select
                              name="lines"
                              className="form-control px-5"
                              onChange={this.handleLimitChange}
                              value={lines}
                            >
                              <option value="">- Select Number of Lines -</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                              <option value="1500">1500</option>
                            </select>
                          </CustomInputWithIcon>
                        </div>
                        <div className="col-md-5 col-lg-5">
                          <CustomInputWithIcon icon="text">
                            <input
                              type="text"
                              placeholder="Search..."
                              name="searchTerm"
                              value={searchTerm}
                              className="form-control px-2"
                              onChange={this.handleSearhTerm}
                            />
                          </CustomInputWithIcon>
                        </div>
                        <div className="col-md-1 col-lg-1">
                          <button
                            type="submit"
                            title="Search Logs"
                            className="btn btn-primary btn-sm"
                          >
                            <i className={`wb ${drapcodeIcon('search')}`}></i>
                          </button>
                        </div>
                        <div className="col-md-3 col-lg-3">
                          <Select
                            name="environment"
                            isMulti={false}
                            className="custom-select-container"
                            classNamePrefix="custom-select"
                            options={environmentSwitchOptions}
                            value={environment}
                            onChange={this.handleEnvironmentChange}
                            // styles={colourStyles}
                            getOptionLabel={(e) => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon && (
                                  <i
                                    className={`wb webconnect-${e.icon}`}
                                    style={{ lineHeight: '0' }}
                                  ></i>
                                )}
                                <span style={{ marginLeft: 5 }}>{e.label}</span>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    </form>
                    {loadPreviewLogsPending || loadProjectDetailPending ? (
                      <div className="text-center">
                        <CustomLoader
                          loading={loadPreviewLogsPending}
                          size="20px"
                          color="#303453"
                        />
                      </div>
                    ) : (
                      <AceEditor
                        mode="markdown"
                        theme="github"
                        value={logs}
                        rows={10}
                        fontSize={16}
                        showPrintMargin={false}
                        width="100%"
                        height="700px"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    logger: state.logger,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
